/* eslint-disable */

const slick = require('slick-carousel');

var ar_dir = false;
if ($('body').hasClass('ar') || $('body').hasClass('Ar')) {
	ar_dir = true;
}

var productsSlicksSettings = {
	arrows: false,
	centerMode: true,
	dots: true,
	rtl: ar_dir,

	cssEase: 'linear',
	slidesToShow: 4,
	pauseOnDotsHover: true,
	centerPadding: '120px',
	autoplay: true,

	autoplaySpeed: 1700,
	responsive: [{
			breakpoint: 1400,
			settings: {
				centerPadding: '90px',
				slidesToShow: 3,

			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,

				centerPadding: '40px',
			}
		},
		{
			breakpoint: 480,
			settings: {

				centerPadding: '20px',
				slidesToShow: 2
			}
		}
	]
};

if ($('.imgs-gallery').length) {

	$('.imgs-gallery').slick({
		arrows: false,
		// centerMode: true,
		dots: true,
		rtl: ar_dir,

		cssEase: 'linear',
		fade: true,

		// centerPadding: '220px',
		slidesToShow: 1,
		autoplay: true,
		// pauseOnHover: false,
		autoplay: true,
		autoplaySpeed: 1500,
		speed: 1300,

		responsive: [{
				breakpoint: 768,
				settings: {
					arrows: false,
					// centerMode: true,
					// centerPadding: '40px',
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: false,
					// centerMode: true,
					// centerPadding: '40px',
					slidesToShow: 1
				}
			}
		]
	});
}

if ($('.tab-content').length > 0) {
	$('.tab-content .tab-pane:not(:first)').removeClass('active');
}


$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
	console.log(' e.target', $(e.target).attr('href'));
	let targetActive = $(e.target).attr('href');

	var slide_wdth = $(targetActive).find('.products-gallery .slick-active').width();
	// console.log('slide_wdth:' + slide_wdth);
	if (slide_wdth < 2) {
		$(targetActive).closest('.tab-content').addClass('waitLoading')

		// console.log('slide_wdth');
		$(targetActive).find('.products-gallery').slick('unslick').slick(productsSlicksSettings);
		$(targetActive).closest('.tab-content').removeClass('waitLoading')

	} else {
		$(targetActive).closest('.tab-content').removeClass('waitLoading')

	}


})
if ($('.products-gallery').length) {

	$('.products-gallery').slick(productsSlicksSettings);
}





//Smart Header Functions
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = '';

navbarHeight = $(".header").innerHeight();
$(window).scroll(function () {


	didScroll = true;
	setInterval(function () {
		if (didScroll) {
			geekflare_hasScrolled();
			didScroll = false;
		}
	}, 250);
	//end Header Functions



});

//Smart Header Functions

function geekflare_hasScrolled() {
	var st = $(window).scrollTop();
	// Make sure to scroll more than delta
	if (Math.abs(lastScrollTop - st) <= delta)
		return;

	if (st > 30 && st > navbarHeight) {

		// Scroll Down

		$('.header').css('top', -navbarHeight - 120).removeClass('shadow1');
		$('body').addClass('scrolledHeader');
		//$('.animated .navigation .nav-item,.header.animated .social-icons li').removeClass('show');

	} else {

		// Scroll Up
		if (st + $(window).height() < $(document).height()) {




		}
	}

	if (st < 80) {
		$('.header').css('top', 0).removeClass('shadow1');
		$('body').removeClass('scrolledHeader');

	}

	lastScrollTop = st;
}
